// import { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

//route components
import { loggedInMenuComponent } from '../../components/loginmenu/logedinmenu.component';
import { DashboardComponent } from '../../components/dashboard/dashboard.component';
import { signupComponent } from '../../components/signup/signup.component';
import { loginComponent } from '../../components/login/login.component';
import { quickPayComponent } from '../../components/quickPay/quickPay.component';
import { faqComponent } from '../../components/faq/faq.component';
import { dashboardCatComponent } from '../../components/dashboardCategory/dashBoardCategory.component';
import { mybillsComponent } from '../../components/mybills/mybills.component';
import { myProfileComponent } from '../../components/profile/myProfile.component';
import { myCompComponent } from '../../components/mycomp/myComp.component';
import { newPaymentResponseComponent } from '../../components/paymentResponse/paymentResponse.component';
import { paymentResponseComponent } from '../../components/success/paymentResponse.component';
import { broadcastComponent } from '../../components/broadcast/broadcast.component';
import { nscComponent } from '../../components/nsc/nsc.component';
import { disclaimerComponent } from '../../components/disclaimer/disclaimer.component';
import { privacyComponent } from '../../components/privacy/privacy.component';
import { consumerCenterComponent } from '../../components/consumerCenter/consumerCenter.component';
import { NewNscComponent } from '../../components/newnsc/newnsc.component';
import { NewNscRegComponent } from '../../components/newNscReg/newNscReg.component';
import { NewConnectionLoginComponent } from '../../components/newConnectionLogin/newConnectionLogin.component';
import { ConsumerBasicInfoComponent } from '../../components/consumerBasicInfo/consumerBasicInfo.component';
import { DocumentUploadComponent } from '../../components/documentUpload/docUpload.component';
import { PaymentNscComponent } from '../../components/payment-nsc/payment-nsc.component';
import { PaymentDetailsComponent } from '../../components/payment-details/payment-details.component';
import { TransactionDetailsComponent } from '../../components/transaction-details/transaction-details.component';
import { grevienceMangementComponent } from '../../components/grevience/grevienceMangement.component';
import { FeedbackComponent } from "../../components/feedback/feedback.component";
//import { requestMangementComponent } from '../../components/request/requestMangement.component';
import { ConnectionManagementComponent } from '../../components/connection-management/connection-management.component';
import { ChangePasswordComponent } from '../../components/change-password/change-password.component';
import { SolarPvComponent } from '../../components/solar-pv/solar-pv.component';
import { PrepaidBalanceComponent } from 'app/components/prepaid-balance/prepaid-balance.component';
import { PrepaidPaymentSuccessComponent } from 'app/components/prepaid-payment-success/prepaid-payment-success.component';
import { PrepaidPaymentFailComponent } from 'app/components/prepaid-payment-fail/prepaid-payment-fail.component';
import { PrepaidSuccessMobileComponent } from 'app/components/prepaid-success-mobile/prepaid-success-mobile.component';
import { ViewPrepaidTransactionComponent } from 'app/components/view-prepaid-transaction/view-prepaid-transaction.component';
import { PrepaidConsumptionComponent } from 'app/components/prepaid-consumption/prepaid-consumption.component';

const router: Routes = [
	{ path: '', component: DashboardComponent },
	{ path: 'dashboard', component: DashboardComponent },
	{ path: 'register', component: signupComponent },
	{ path: 'grevience', component: grevienceMangementComponent },
	//{ path: 'request', component: requestMangementComponent},
	//{ path: 'login', component: ConsumerBasicInfoComponent},
	{ path: 'login', component: loginComponent },
	{ path: 'quickpay', component: quickPayComponent },
	{ path: 'faq', component: faqComponent },
	{ path: 'bill', component: mybillsComponent },
	{ path: 'myprofile', component: myProfileComponent },
	{ path: 'myconsumption', component: myCompComponent },
	//{ path: 'paymentstatus/:msg', component: paymentResponseComponent},
	{ path: 'paymentstatusmsg/:msg', component: newPaymentResponseComponent },
	// { path: 'paymentstatusmsg', component: newPaymentResponseComponent},
	{ path: 'broadcast', component: broadcastComponent },
	{ path: 'disclaimer', component: disclaimerComponent },
	{ path: 'nsc', component: nscComponent },
	{ path: 'privacy', component: privacyComponent },
	{ path: 'cosumercentres', component: consumerCenterComponent },
	{ path: 'newNscCompnt', component: NewNscComponent },
	{ path: 'newNscRegCompnt/:id', component: NewNscRegComponent },
	{ path: 'newConnectionLogin', component: NewConnectionLoginComponent },
	{ path: 'consumerBasicInfo/:id', component: ConsumerBasicInfoComponent },
	{ path: 'consumerBasicInfot', component: ConsumerBasicInfoComponent },
	{ path: 'documentUploadComponent/:consumerData', component: DocumentUploadComponent },
	{ path: 'paymentNsc', component: PaymentNscComponent },
	{ path: 'transactionDetails', component: TransactionDetailsComponent },
	{ path: 'paymentDetails', component: PaymentDetailsComponent }, 
	{ path: 'feedback', component: FeedbackComponent },
	{ path: 'connectionManagement', component: ConnectionManagementComponent },
	{ path: 'reset-password', component: ChangePasswordComponent },
	{ path: 'solar-pv', component: SolarPvComponent },
	{ path: 'prepaid-balance', component: PrepaidBalanceComponent },
	{ path: 'prepaid-payment-success', component: PrepaidPaymentSuccessComponent },
	{ path: 'prepaid-payment-fail', component: PrepaidPaymentFailComponent },
	{ path: 'prepaid-payment-success-mobile', component: PrepaidSuccessMobileComponent},
	{ path: 'view-prepaid-transaction', component: ViewPrepaidTransactionComponent},
	{ path: 'prepaid-consumption', component: PrepaidConsumptionComponent}
];

// export const routes: ModuleWithProviders = RouterModule.forRoot(router);

@NgModule({
	imports: [RouterModule.forRoot(router, {
		// preload all modules; optionally we could
		// implement a custom preloading strategy for just some
		// of the modules (PRs welcome 😉)
		preloadingStrategy: PreloadAllModules,
		useHash: true
	})],
	exports: [RouterModule]
})
export class AppRoutingModule { }

export const routingComponents = [
	DashboardComponent,
	signupComponent,
	dashboardCatComponent,
	loginComponent,
	quickPayComponent,
	grevienceMangementComponent,
	//requestMangementComponent,
	faqComponent,
	loggedInMenuComponent,
	mybillsComponent,
	myProfileComponent,
	myCompComponent,
	//paymentResponseComponent,	
	newPaymentResponseComponent,
	broadcastComponent,
	nscComponent,
	disclaimerComponent,
	privacyComponent,
	consumerCenterComponent,
	NewNscComponent,
	NewNscRegComponent,
	NewConnectionLoginComponent,
	ConsumerBasicInfoComponent,
	DocumentUploadComponent,
	PaymentNscComponent,
	TransactionDetailsComponent,
	FeedbackComponent,
	ConnectionManagementComponent,
	SolarPvComponent,
	PrepaidBalanceComponent,
	PrepaidPaymentSuccessComponent,
	PrepaidPaymentFailComponent,
	PrepaidSuccessMobileComponent,
	PrepaidConsumptionComponent
]



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/config/routes/app.routes.ts